import { RemoveCircle } from '@mui/icons-material';
import { Box, Button, Card, Grid, IconButton, Stack, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import CommonQuillEditor from 'common/editor';
import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { openSnackbar } from '../../redux/slices/common';
import { updateMainFAQ } from '../../redux/slices/faq';
import MDButton from 'components/MDButton';
import { useDispatch } from 'react-redux';
import { getData } from 'utilities/common';
import { getPermissionsByMode } from 'utilities/common';
import { hasSectionPermission } from 'utilities/common';
import DeleteIcon from "common/customIcons/delete";

export default function MainFAQForm() {
  const [formData, setFormData] = useState({ faq: [] });
  const { faqs = [], loading } = useSelector(state => state.mainFAQ);
  const dispatch = useDispatch();

  const handleChangeFAQ = (value, fieldType, idx) => {
    let FAQArray = [...formData?.faq];
    let faqItem = FAQArray?.find(((faq, _idx) => _idx === idx));
    if (faqItem) {
      const faqItemIdx = FAQArray.indexOf(faqItem);
      faqItem = {
        ...faqItem,
        [fieldType]: value
      };
      FAQArray[faqItemIdx] = faqItem;
      setFormData({ ...formData, faq: FAQArray });
    }
  };

  const addFAQHandler = () => {
    let newFAQ = [...formData?.faq];
    let faqItem = {
      question: '',
      answer: ''
    };
    newFAQ = [...newFAQ, faqItem];
    setFormData({ ...formData, faq: newFAQ });
  };

  const handleRemoveFAQ = (faQIdx) => {
    let FAQArray = [...formData?.faq];
    FAQArray = FAQArray?.filter(((faq, _idx) => _idx !== faQIdx));
    setFormData({ ...formData, faq: FAQArray });
  };

  const updateFAQHandler = () => {
    dispatch(updateMainFAQ({ faq: formData.faq })).unwrap().then((res) => {
      showResponseMessage(res?.message, 'success');
    }).catch((err) => {
      showResponseMessage(err?.message, 'error');
    });
  };

  const showResponseMessage = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };


  useEffect(() => {
    if (faqs?.length > 0) {
      setFormData({ ...formData, faq: faqs });
    }
  }, [faqs]);

  let localUser = getData('login-user-info')
  if (localUser) {
    localUser = JSON.parse(localUser)
  }

  const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
  const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

  const canCreate = hasSectionPermission(permissionsForMode, "Manage Website", "Create");
  const canEdit = hasSectionPermission(permissionsForMode, "Manage Website", "Edit/Update");
  const canView = hasSectionPermission(permissionsForMode, "Manage Website", "View Only");

  return (
    <CommonLayout>
      {
        canView &&
        <Box p={{ xs: 2, sm: 3, lg: 4 }}>
          <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
            <Typography variant='h4' fontWeight="semibold" color="secondary">Homepage FAQ</Typography>
          </Box>
          <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: 'none' }}>
            <Box>
              {
                formData?.faq?.length > 0 ? <>
                  {
                    formData?.faq?.map(((faq, idx) => {
                      return <Grid key={idx} item xs={12} sm={12} lg={12} my={2} className="faq-sec-rep">
                        <Grid container alignItems='flex-start'>
                          <Grid item xs={12} lg={12} md={12}>
                            <Box display='flex' justifyContent='center' alignItems={'flex-start'}>
                              <Box width={'100%'}>
                                <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Question</Typography>
                                <CommonQuillEditor
                                  allowImage={false}
                                  value={faq?.question || ''}
                                  onChange={(value) => handleChangeFAQ(value, 'question', idx)}
                                />
                              </Box>
                              {
                                (canCreate || canEdit) &&
                                <Box className="remove-btn">
                                  <IconButton onClick={() => handleRemoveFAQ(idx)}>
                                    <DeleteIcon color='error' />
                                  </IconButton>
                                </Box>
                              }
                            </Box>
                          </Grid>
                        </Grid>
                        <Grid container alignItems='flex-start' mt={2}>
                          <Grid item xs={12} lg={12} md={12}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Answer</Typography>
                            <CommonQuillEditor
                              allowImage={false}
                              value={faq?.answer || ''}
                              onChange={(value) => handleChangeFAQ(value, 'answer', idx)}
                            />
                          </Grid>
                        </Grid>
                      </Grid>;
                    }))
                  }
                </> : <Box display='flex' justifyContent='space-between' alignItems={'center'} my={3}>
                  <Button
                    disabled={!canCreate && !canEdit}
                    sx={{ minWidth: '160px' }}
                    type='button'
                    onClick={addFAQHandler}
                    variant='contained'
                    color='primary'
                  >Add FAQ</Button>
                </Box>
              }
            </Box>
            {(canCreate || canEdit) &&
              formData?.faq?.length > 0 && <Box>
                <Button
                  sx={{ minWidth: '160px' }}
                  type='button'
                  onClick={addFAQHandler}
                  variant='contained'
                  color='primary'
                >Add FAQ</Button>
              </Box>
            }
          </Card>
          <Box mt={2}>
            {(canCreate || canEdit) &&
              // faqs?.length > 0 &&
              <MDButton
                sx={{ width: '160px' }}
                type='button'
                onClick={updateFAQHandler}
                variant='contained'
                disabled={loading}
                loading={loading}
                color='primary'
              >Save</MDButton>
            }
          </Box>
        </Box>
      }
    </CommonLayout>
  );
}